import React, { useState } from 'react';
import { ReactComponent as SortIcon } from '../../../../assets/images/icon-sort.svg';
import { useStyles } from '../styles';

interface IListSort {
    title: string;
    onClick: (sortOption: IOption) => void;
    sortOptions: IOption[];
    selectedSortOption?: IOption;
}
export interface IOption {
    key: string;
    value: string;
    sort: string;
}

export function ListSort({ title, onClick, sortOptions, selectedSortOption }: IListSort) {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const classes = useStyles();
    function renderOptions() {
        return sortOptions.map((option: IOption) => {
            return (
                <li
                    key={option.key}
                    onClick={() => {
                        onClick(option);
                        setIsOpen(false);
                    }}
                    data-component-name={option.value}
                >
                    <p>{option.value}</p>
                </li>
            );
        });
    }
    return (
        <div className={classes.sortButtonWrapper} tabIndex={-1} onBlur={() => setIsOpen(false)}>
            <div onClick={() => setIsOpen(!isOpen)} data-component-name="SORT_BUTTON" className={classes.filterBtn}>
                <SortIcon />
                {selectedSortOption ? (
                    <p>
                        {title}: <strong>{selectedSortOption.value}</strong>
                    </p>
                ) : (
                    <p>{title}</p>
                )}
            </div>
            {isOpen && <ul className={classes.sortOptions}>{renderOptions()}</ul>}
        </div>
    );
}
